import { EVENT_NAME, SYNCING_STATUS } from "constants/phase";
import { v4 as uuidv4 } from "uuid";

export const convertClipsToVideosData = (clips, aspectRatio = "16:9") => {
  return clips.map((clip) => {
    let url = "";

    if (clip?.aspectRatio === aspectRatio) {
      url = clip?.videoUrl;
    } else {
      url =
        clip?.editedVideos?.find(
          ({ aspect_ratio, status, event }) =>
            aspect_ratio === aspectRatio && status !== SYNCING_STATUS.PROCESSING && event !== EVENT_NAME.DYNAMIC,
        )?.video_url || clip?.videoUrl;
    }

    return {
      type: "clip",
      id: uuidv4(),
      duration: clip?.duration || 0,
      variantUrl: clip?.variantUrl,
      originalUrl: url,
      url: clip?.variantUrl || url,
      streamId: clip?.streamId,
      startTime: clip?.start_time,
      clipData: clip,
    };
  });
};

export const convertBumperToVideosData = (bumper) => ({
  type: "bumper",
  id: uuidv4(),
  duration: bumper.duration,
  url: bumper.url,
  bumperData: bumper,
});

export const getBumpersMetadataPayload = (_videos, deleteBumperId) => {
  const bumpers = [];
  let videos = _videos;

  if (deleteBumperId) {
    videos = videos.filter((video) => video.id !== deleteBumperId);
  }

  videos.forEach((video, idx) => {
    if (video.type === "bumper") {
      const bumperDetails = {
        bumperId: video.bumperData?._id,
        id: video.id,
        position: idx,
      };

      bumpers.push(bumperDetails);
    }
  });

  return bumpers;
};

export const insertBumpersAtPositions = (_videosArray, bumpersArray) => {
  const videosArray = _videosArray.filter((video) => video.type !== "bumper");

  if (!bumpersArray?.length) return videosArray;

  const resultSize = videosArray.length + bumpersArray.length;
  const result = new Array(resultSize).fill(undefined);

  // Insert unique bumpers at specified positions
  for (const bumper of bumpersArray) {
    result[bumper.position] = bumper;
  }

  // Fill in the rest with videos
  let videoIndex = 0;
  for (let i = 0; i < result.length && videoIndex < videosArray.length; i++) {
    if (result[i] === undefined) {
      result[i] = videosArray[videoIndex++];
    }
  }

  return result;
};

export const getImgStateFromScaledCoords = (coords, containerWidth, containerHeight) => {
  const [top_left_x, top_left_y, bottom_right_x, bottom_right_y] = coords;
  const scale = 100;

  const x = (top_left_x / scale) * containerWidth;
  const y = (top_left_y / scale) * containerHeight;
  const width = ((bottom_right_x - top_left_x) / scale) * containerWidth;
  const height = ((bottom_right_y - top_left_y) / scale) * containerHeight;

  return { x, y, width, height };
};
